import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AddressWidget from '../AddressWidget/AddressWidget';
import CodeWidget from '../CodeWidget/CodeWidget';
import ConfirmationWidget from '../ConfirmationWidget/ConfirmationWidget';


const CodeForm = () => {


  const { codeParam } = useParams();
  const [campaignInfo, setCampaignInfo] = useState({
    greeting: 'Grüezi',
    code: '',
    name: '',
    firstName: '',
    street: '',
    streetNr: '',
    zip: '',
    town: '',
    phone: '',
    eMail: '',
    marketing: false,
    text: 'Aktiviere jetzt deinen persönlichen Vorteilscode und erhalte eine Fachberatung im Wert von CHF 1000.-',
    url: '',
    status: ''
  });

  const [codeWidgetVisible, setCodeWidgetVisible] = useState(true)
  const [addressWidgetVisible, setAddressWidgetVisible] = useState(false)
  const [confirmationWidgetVisible, setConfirmationWidgetVisible] = useState(false)

  // useEffect() with deps [] is run only on first render...
  useEffect(() => {
    console.log("Init:" + codeParam)
    if (!codeParam) {
      setCodeWidgetVisible(true);
      setAddressWidgetVisible(false);
    } else {
      onCodeSubmitted(codeParam)
    }

  }, [])

  async function postData(url = "", data = {}) {
    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(data),
      });
      return await response.json();
    }
    catch (error) {
      console.log(error)
    }
  }

  function onCodeSubmitted(code) {
    console.log("codeSubmited(): Code: " + code)
    fetch("https://prod-253.westeurope.logic.azure.com/workflows/f1f1692d596944ae843cc6057e8d439d/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=rSyN0kPWPDn6xuuBlPQfVdrar5aktE31GGLi5W6nXqQ&code=" + code, {
      mode: 'cors',
      redirect: "follow",
      referrerPolicy: "no-referrer"
    })
      .then(response => response.json())
      .then(data => {
        setCampaignInfo((previousCampaignInfo) => ({ ...previousCampaignInfo, ...data }))
        setCodeWidgetVisible(false)
        setAddressWidgetVisible(true)
      });
  }

  async function onAddressSubmitted(name, firstName, street, streetNr, zip, town, phone, eMail, marketing, code) {
    console.log("AddressSubmitted(): Name: " + name + ", First name: " + firstName + ",  Street: " + street + ",  StreetNr: " + streetNr + ", Marketing: " + marketing + " Code: " + code)
    const data = {
      code: code,
      name: name,
      firstName: firstName,
      street: street,
      streetNr: streetNr,
      zip: zip,
      town: town,
      phone: phone,
      eMail: eMail,
      marketing: marketing,
      url: '',
      status: ''
    }

    const postResponse = await postData("https://prod-129.westeurope.logic.azure.com:443/workflows/1585dfd6b907434680bb5a858d70c1fa/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=1UkaNGkd82nrzYjEznYaFgPsXdUV2lUNWAY0BNTdk9c", data);

    setCampaignInfo((previousCampaignInfo) => ({ ...previousCampaignInfo, ...data, ...postResponse }));
    setAddressWidgetVisible(false)

    setConfirmationWidgetVisible(true)
  }


  return (
<>
          {codeWidgetVisible && <CodeWidget id="codeWidget" onCodeSubmitted={onCodeSubmitted} />}

      
      {addressWidgetVisible && <AddressWidget onAddressSubmitted={onAddressSubmitted} campaignInfo={campaignInfo} />}
      {confirmationWidgetVisible && <ConfirmationWidget campaignInfo={campaignInfo} />}
      <br />
      </>
  );
}


export default CodeForm;
